define('config/composition',[
    'underscore',
    'common/config/cookieAccessors',
    'common/config/params',
    'common/config/services',
    'config/params',
    'config/knockoutCustomisations'
], function (
    _,
    commonCookieAccessors,
    commonParams,
    commonServices,
    params,
    knockoutCustomisations
) {

    var composition = {

        params: _.extend({}, commonParams, params),

        cookieAccessors: commonCookieAccessors,

        services: _.extend({}, commonServices, knockoutCustomisations, {

            safeBrowsingEnabledStorage: {
                factoryService: 'localStorageAccessorFactory',
                args: ['%safeBrowsingEnabledStorageKey']
            },
            // @todo There is a circular dependency in abTesting for mobile
            abTesting: {
                module: 'utils/noop',
                init: 'return'
            },

            /**
             * Local Storage Accessors
             */
            sessionHistoryStorage: {
                factoryService: 'localStorageAccessorFactory',
                args: ['%localStorageKeys.sessionHistory']
            },

            olarkStorage: {
                factoryService: 'localStorageAccessorFactory',
                args: ['%localStorageKeys.olarkStorageKey']
            },
            /**
             * Feature: emailVerification
             */
            emailVerificationDisplay: {
                module: 'features/emailVerification/EmailVerificationDisplay',
                args: [
                    '@plugins/dialog',
                    '@ErrorAlert',
                    '@EmailVerificationViewModel',
                    'fe:wp:page:root:mobile/errors'
                ]
            },

            /**
             * Model
             */
            ChangePasswordToken: {
                module: 'model/SecurityToken',
                init: 'partial',
                args: ['Query:common:player/passwordResetTicketCheck']
            },

            GameRunner: {
                module: 'gameBrowser/GameRunner',
                init: 'partial',
                args: [
                    'LOG',
                    '@session',
                    '@settings',
                    'PlatformCmd:launchGame:common',
                    '@GameProviderModel',
                    '@gameLaunchStrategyInjector'
                ]
            },

            actionProvider: {
                module: 'core/actionProvider',
                init: 'factory',
                args: [
                    'LOG',
                    '@session',
                    '@itemManager',
                    '@navigation',
                    '@settings',
                    '@offerSelector'
                ]
            },

            actions: {
                module: 'core/actions',
                args: [
                    '@navigation',
                    '@TermsDialog',
                    '@CookieDialog'
                ],
                extras: [
                    {
                        subscribe: {
                            handleNoLoggedOutFreeplay: 'showLogin'
                        }
                    }
                ]
            },

            changePasswordModel: {
                module: 'model/ChangePasswordModel',
                args: [
                    'PlatformCmd:changePassword:common',
                    '@ChangePasswordToken',
                    '@values'
                ]
            },

            changeRealityCheckIntervalModel: {
                module: 'model/ChangeRealityCheckIntervalModel',
                args: [
                    'PlatformCmd:changeRealityCheckInterval:common',
                    '@validity',
                    '@values'
                ]
            },

            connectivity: {
                module: 'common/Connectivity'
            },

            forgotPasswordModel: {
                module: 'model/ForgotPasswordModel',
                args: [
                    'PlatformCmd:requestNewPassword:common',
                    '@values'
                ]
            },

            frameworkApp: {
                module: 'common/utils/identity',
                init: 'factory',
                args: ['@durandal/app']
            },

            gamesInterface: {
                module: 'common/utils/identity',
                init: 'factory',
                args: [
                    '@games.mobileGames'
                ]
            },

            gameBrowser: {
                module: 'gameBrowser/GameBrowser',
                args: [
                    'wp:page:market:mobile2-game-browser',
                    '@games.mobileGames'
                ]
            },

            redirectToGameLaunchStrategy: {
                module: 'gameBrowser/redirectToGameLaunchStrategy',
                init: 'return'
            },

            redirectToGameOverlayLaunchStrategy: {
                module: 'gameBrowser/redirectToGameOverlayLaunchStrategy',
                init: 'partial',
                args: [
                    '@overlayGame2'
                ]
            },

            gameLaunchStrategyInjector: {
                module: 'gameBrowser/gameLaunchStrategyInjector',
                args: [
                    '@redirectToGameLaunchStrategy',
                    '@redirectToGameOverlayLaunchStrategy',
                    '@gameLauncherStrategyOverride'
                ]
            },

            gameLauncher: {
                module: 'common/GameLauncher',
                args: [
                    '@GameRunner',
                    '@games'
                ]
            },

            gameTopLists: {
                module: 'gameBrowser/TopLists',
                args: [
                    '@session',
                    '@games.mobileGames',
                    'wp:page:market:mobile2-game-browser'
                ]
            },

            itemHandler: {
                module: 'core/ItemHandler',
                args: [
                    '@navigation',
                    'defer:@gameLauncher',
                    'defer:@games',
                    '@plugins/dialog',
                    '@CouponDialog',
                    '@TicketDialog',
                    '@ErrorAlert',
                    'fe:wp:page:root:mobile/errors'
                ]
            },

            itemManager: {
                module: 'core/ItemManager',
                args: [
                    'LOG',
                    '@cometd',
                    '@session',
                    'publish:onItemNotSupportedOnDevice',
                    'PlatformCmd:player/coupon/reservation:common',
                    '@itemHandler.onTicketUsed',
                    'publish:onPlaceholderUsed',
                    '@itemHandler.onCouponUsed',
                    '@itemHandler.onDepositItemUsed',
                    '@itemHandler.onFreeSpinsActivated',
                    '@itemHandler.onFreespinsRecycled'
                ]
            },

            loadingState: {
                module: 'model/LoadingState',
                args: [
                    '@plugins/router.isNavigating',
                    '@globalCommandListener.loading',
                    '@itemManager.loading'
                ]
            },

            loginModel: {
                module: 'model/LoginModel',
                args: [
                    'PlatformCmd:login:common',
                    '@session',
                    'publish:onLoginDataAccepted',
                    'publish:onLoginFailed',
                    '@noop',
                    '%login.maxAttempts',
                    '@values',
                    '@trackDeviceInfo'
                ]
            },

            paymentsRules: {
                init: 'return',
                module: 'model/payments/rules'
            },

            sessionHistory: {
                module: 'core/session/SessionHistory',
                args: ['@sessionHistoryStorage'],
                extras: [
                    {
                        subscribe: {
                            onLogin: 'handleLogin'
                        }
                    }
                ]
            },

            signUpModel: {
                module: 'model/SignUpModel',
                args: [
                    'PlatformCmd:registerPlayer:common',
                    '@welcomeOffers',
                    '@internationalization',
                    '@settings',
                    '@offerSelector',
                    '@validity',
                    '@values',
                    '@trackDeviceInfo',
                    '@session',
                    '@noop'
                ]
            },

            settingsModel: {
                module: 'model/SettingsModel',
                args: [
                    '@session.player',
                    '@values',
                    '@validity',
                    '@Command',
                    '@PlatformCommandDispatcher',
                    'PlatformCmd:changeEmail:common',
                    'PlatformCmd:directChangePassword:common',
                    'PlatformCmd:verifyPhoneNumber/verify:common',
                    'PlatformCmd:verifyPhoneNumber/requestVerificationCode:common'
                ]
            },

            // @todo Is this useful for site?
            tacVersionListener: {
                module: 'core/tacVersionListener',
                init: 'partial',
                args: [
                    '@Command',
                    '@PlatformCommandDispatcher',
                    '@cometd',
                    '@plugins/dialog',
                    '@TermsDialog'
                ],
                extras: [
                    {
                        subscribe: 'onSessionPlayer'
                    }
                ]
            },

            validations: {
                module: 'model/validations',
                init: 'return'
            },

            values: {
                module: 'model/Values',
                args: ['@validity']
            },

            /**
             * Model - Payments
             */
            depositModel: {
                module: 'model/payments/DepositModel',
                args: [
                    '@values',
                    '@validity',
                    '@paymentMethodFactory.depositMethodModel',
                    '@sendPiqDepositRequest',
                    '@absoluteUrls.waitForTransactionUrl',
                    '@session.player',
                    '%defaultDepositAmount',
                    'publish:onDeposit'
                ]
            },

            sendPiqDepositRequest: {
                init: 'partial',
                module: 'model/payments/sendPiqRequest',
                args: ['@piqApi.deposit']
            },

            /**
             * ViewModel
             */
            PaymentWizard: {
                module: 'viewmodels/pages/cash/PaymentWizard',
                init: 'partial',
                args: [
                    'publish:onWizardStepChanged'
                ]
            },

            Wizard: {
                module: 'viewmodels/Wizard',
                init: 'partial',
                args: ['publish:onWizardStepChanged']
            },

            aboutViewModel: {
                module: 'viewmodels/pages/about',
                args: ['fe:wp:page:root:mobile/about-us']
            },

            notFoundViewModel: {
                module: 'viewmodels/pages/404',
                args: ['fe:wp:page:root:mobile/404-2']
            },

            faqViewModel: {
                module: 'viewmodels/pages/faq',
                args: [
                    'fe:wp:page:root:mobile/faq',
                    '@FaqDialog',
                    '@FaqDialogTablet'
                ]

            },

            playOkayViewModel: {
                module: 'viewmodels/pages/playOkay',
                args: [
                    'fe:wp:page:root:mobile/playOkay',
                    '@PlayOkayDialog'
                ]

            },

            cashTabs: {
                module: 'viewmodels/pages/cash/cashTabs',
                init: 'factory',
                args: [
                    '@navigation',
                    'fe:wp:page:root:mobile/deposit',
                    'fe:wp:page:root:mobile/withdraw',
                    'fe:wp:page:root:mobile/payment-history'
                ]
            },

            depositFormFields: {
                module: 'core/FormFields',
                args: [
                    '@settings.selectedLanguage',
                    '@settings.selectedCountry',
                    '@internationalization.countries',
                    'wp:page:root:mobile/forms',
                    'wp:page:root:mobile/deposit'
                ]
            },

            formFields: {
                module: 'core/FormFields',
                args: [
                    '@settings.selectedLanguage',
                    '@settings.selectedCountry',
                    '@internationalization.countries',
                    'wp:page:root:mobile/forms'
                ]
            },

            iddqdViewModel: {
                module: 'viewmodels/pages/iddqd',
                args: [
                    '@navigation',
                    '@debugModeEnabledFlag',
                    '@showDisabledGamesFlag',
                    '@gameLauncherStrategyOverride',
                    '@adventureOverride',
                    '@session',
                    '@settings',
                    '@internationalization',
                    '@tournamentsOverrideViewModel'
                ]
            },

            imageOptimizer: {
                module: 'utils/ImageOptimizer',
                args: ['%imageDomainMappings']
            },

            // This is overridden in the nativeComposition for native app, any changes here should be checked
            // there
            loginViewModel: {
                module: 'viewmodels/pages/login',
                args: [
                    '@loginModel',
                    'fe:wp:page:root:mobile/sign-in',
                    '@navigation',
                    '@vocabulary',
                    '@sessionHistory',
                    '@ChooseAccountDialog',
                    '@ForgotPasswordDialog',
                    '@ChoiceAlert',
                    '@formFields',
                    'publish:onLoginPageActivated'
                ],
                extras: [
                    {
                        subscribe: {
                            handleNoLoggedOutFreeplay: 'handleNoLoggedOutFreeplay'
                        }
                    }
                ]
            },

            notificationsViewModel: {
                module: 'viewmodels/notifications',
                args: [
                    '@session',
                    '@actionProvider',
                    'fe:wp:page:root:mobile/notifications',
                    '@plugins/dialog',
                    '@NotificationsDialog',
                    '@gameLauncher'
                ]
            },

            offlineMessageViewModel: {
                module: 'features/offlineMessage/offlineMessage',
                args: [
                    '@connectivity',
                    'fe:wp:page:root:mobile/errors'
                ]
            },

            onMenuNavigationCompletedPublisher: {
                module: 'core/onMenuNavigationCompletedPublisher',
                args: [
                    '@mediaResponder',
                    '@navigation',
                    'publish:onMenuNavigationCompleted'
                ],
                extras: [
                    {
                        subscribe: {
                            onMenuClosed: 'onMenuClosed',
                            onNavigation: 'onNavigation'
                        }
                    }
                ]
            },

            playViewModel: {
                module: 'viewmodels/pages/play',
                args: [
                    '@plugins/router',
                    '@session',
                    '@games',
                    '@navigation',
                    'fe:wp:page:root:mobile/game-details'
                ]
            },

            reelRacesViewModel: {
                module: 'viewmodels/pages/reelRaces/reelRaces',
                args: [
                    '@playerTabs',
                    'fe:wp:page:root:reel-races/reel-race-templates',
                    'fe:wp:page:root:mobile/reel-races',
                    '@games.mobileGames',
                    '@tournamentCampaignsViewModel',
                    '@ReelRacesHowItWorksDialog',
                    '@plugins/dialog'
                ]
            },

            playerDashboardViewModel: {
                module: 'viewmodels/pages/player/dashboard',
                args: [
                    '@playerTabs',
                    'fe:wp:page:root:mobile/dashboard',
                    '@tournamentCampaignsViewModel',
                    '@session',
                    '@adventurers',
                    'fe:wp:page:root:mobile/adventure'
                ]
            },

            playerTabs: {
                module: 'viewmodels/pages/player/playerTabs',
                init: 'factory',
                args: [
                    '@navigation',
                    'fe:wp:page:root:mobile/dashboard',
                    'fe:wp:page:root:mobile/valuables',
                    'fe:wp:page:root:mobile/tournament-campaigns/guns-n-roses'
                ]
            },

            playerValuablesViewModel: {
                module: 'viewmodels/pages/player/valuables',
                args: [
                    '@session',
                    '@adventurers',
                    '@itemManager',
                    'fe:wp:page:root:mobile/valuables',
                    '@playerTabs',
                    '@tournamentCampaignsViewModel'
                ]
            },

            playerSettingsViewModel: {
                module: 'viewmodels/pages/player/settings/settings',
                args: [
                    '@session.player',
                    'PlatformCmd:setSMSNewsletterSubscription:common',
                    'PlatformCmd:setNewsletterSubscription:common',
                    'fe:wp:page:root:mobile/settings',
                    '@ChangeEmailDialog',
                    '@ChangePasswordDialog',
                    '@ChangeMobileNumberDialog',
                    '@ChangeRealityCheckIntervalDialog',
                    '@changeRealityCheckIntervalModel',
                    'wp:page:root:shared/reality-check',
                    'publish:onCanReceivePluggableSettings'
                ]
            },

            phoneNumberChangeViewModel: {
                module: 'viewmodels/pages/player/settings/phoneNumberChange',
                args: [
                    '@session.player',
                    '@settingsModel',
                    '@ChangeMobileNumberDialog',
                    '@VerifyMobileNumberDialog',
                    'fe:wp:page:root:mobile/settings/verify-mobile-number',
                    '@navigation'
                ]
            },

            questViewModel: {
                module: 'viewmodels/models/quests/quest',
                args: [
                    '@quests',
                    '@session',
                    '@plugins/dialog',
                    '@QuestInfoDialog',
                    '@QuestChooserDialog',
                    '@questChooser',
                    '@plugins/router',
                    '@MessageAlert'
                ]
            },

            scrollManager: {
                module: 'core/ScrollManager',
                extras: [
                    {
                        subscribe: {
                            'onNavigationComplete': 'resetScrolls',
                            'onWizardStepChanged': 'resetScrolls',
                            'onMenuOpened': 'resetScrolls',
                            'onTopTabClicked': 'resetScrolls'
                        }
                    }
                ]
            },

            shellViewModel: {
                module: 'viewmodels/shell',
                args: [
                    '@navigation',
                    '@session',
                    '@loadingState',
                    '@ErrorAlert',
                    'fe:wp:page:root:mobile/global-assets',
                    'fe:wp:page:root:mobile/errors',
                    'publish:onAppComposed',
                    'publish:onMenuOpened',
                    'publish:onMenuClosed',
                    '@vocabulary',
                    'publish:onTopTabClicked'
                ],
                extras: [
                    {
                        subscribe: {
                            onNavigation: 'closeMenu'
                        }
                    }
                ]
            },

            showError: {
                module: 'core/showError',
                init: 'partial',
                args: [
                    '@ErrorAlert',
                    'fe:wp:page:root:mobile/errors'
                ]
            },

            signUpViewModel: {
                module: 'viewmodels/pages/signUp',
                args: [
                    '@signUpModel',
                    '@navigation',
                    '@formFields',
                    '@settings',
                    'wp:page:root:mobile/sign-up',
                    '@Wizard',
                    'publish:onRegistration'
                ],
                extras: [
                    {
                        subscribe: {
                            onMenuNavigationCompleted: 'onMenuNavigationCompleted'
                        }
                    }
                ]
            },

            startViewModel: {
                module: 'viewmodels/pages/start',
                args: [
                    'fe:wp:page:root:mobile/start',
                    'fe:wp:page:root:page-modules/sign-up-version-a',
                    'fe:wp:page:root:page-modules/game-browser-module',
                    '@offerSelector',
                    '@games.mobileGames',
                    '@mediaResponder',
                    '@splashScreen'
                ]
            },

            splashScreen: {
                module: 'viewmodels/models/splash',
                args: [
                    'fe:wp:page:root:mobile/summer-campaign-mobile-splash-page',
                    '@shellViewModel.splashHook',
                    '@plugins/dialog',
                    '@ReelRacesHowItWorksDialog',
                    '@navigation',
                    'cookieAccessor:splashPageShownStorage',
                    '@localStorageAccessorFactory'
                ]
            },

            TournamentViewModel: {
                init: 'partial',
                module: 'viewmodels/tournaments/TournamentViewModel',
                args: [
                    '@TournamentDetailsDialog',
                    '@TournamentDetailsCardDialog',
                    'fe:wp:page:root:mobile/tournament-campaigns',
                    'fe:wp:page:root:reel-races/reel-race-templates'
                ]
            },

            TournamentCampaignViewModel: {
                init: 'partial',
                module: 'viewmodels/tournaments/TournamentCampaignViewModel',
                args: [
                    '@TournamentViewModel'
                ]
            },

            TournamentDetailsCardDialog: {
                module: 'viewmodels/tournaments/TournamentDetailsCardDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog'
                ]
            },

            TournamentDetailsDialog: {
                module: 'viewmodels/tournaments/TournamentDetailsDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@subscribeToLeaderboardUpdates'
                ]
            },

            tournamentExcludedGameDialog: {
                module: 'viewmodels/tournaments/TournamentExcludedGameDialog',
                args: [
                    '@gameLauncher',
                    '@plugins/dialog',
                    'fe:wp:page:root:mobile/tournament-campaigns',
                    '@sessionPlayerTournamentCampaign'
                ]
            },

            tournamentCampaignsViewModel: {
                module: 'viewmodels/tournaments/TournamentCampaignsViewModel',
                args: [
                    '@TournamentCampaignViewModel',
                    'wp:page:root:mobile/tournament-campaigns',
                    '@sessionPlayerTournamentCampaign',
                    '@tournamentCampaignOverride'
                ]
            },

            tournamentsOverrideViewModel: {
                module: 'common/tournaments/TournamentsOverrideViewModel',
                args: [
                    'wp:page:root:mobile/tournament-campaigns',
                    '@tournamentCampaignOverride'
                ]
            },

            withdrawFormFields: {
                module: 'core/FormFields',
                args: [
                    '@settings.selectedLanguage',
                    '@settings.selectedCountry',
                    '@internationalization.countries',
                    'wp:page:root:mobile/forms',
                    'wp:page:root:mobile/withdraw'
                ]
            },

            /**
             * Platform
             */

            globalCommandListener: {
                module: 'core/globalCommandListener',
                init: 'factory',
                args: [
                    'LOG',
                    '%commandLoadingTimeout',
                    '@plugins/dialog',
                    '@ErrorAlert',
                    'fe:wp:page:root:mobile/errors'
                ]
            },

            /**
             * Framework
             */
            durandalConfigurer: {
                module: 'config/durandalConfigurer',
                init: 'factory',
                args: [
                    'LOG',
                    '@context',
                    '@durandal/app',
                    '@durandal/binder',
                    '@durandal/system',
                    '@durandal/viewLocator',
                    '%shellViewModelServiceId'
                ],
                extras: [
                    {
                        subscribe: {
                            beforeAppStart: 'beforeAppStart',
                            afterAppStart: 'afterAppStart'
                        }
                    }
                ]
            },

            mediaResponder: {
                module: 'utils/MediaResponder',
                args: ['%breakpoints']
            },

            metaData: {
                module: 'core/metaData',
                args: [
                    '@navigation',
                    '@PageHead'
                ],
                extras: [
                    {
                        subscribe: {
                            onAppComposed: 'setupPageHead',
                            onAppInit: 'setupTitleUpdater'
                        }
                    }
                ]
            },

            modals: {
                module: 'core/Modals',
                args: ['%transitionMappings'],
                extras: [
                    {
                        subscribe: {
                            beforeAppStart: 'addModalContexts'
                        }
                    }
                ]
            },

            // @todo Is this a good pattern for site? Can it be generalised?
            routing: {
                module: 'config/routing',
                init: 'factory',
                args: [
                    '@navigation',
                    '@routeGuards',
                    '%routeIds',
                    '@googleTagManager',
                    '%routeTranslations',
                    '@sessionHistory',
                    'publish:onNavigationComplete',
                    '@routes'
                ],
                extras: [
                    {
                        subscribe: {
                            afterAppStart: 'afterAppStart'
                        }
                    }
                ]
            },

            routes: {
                module: 'config/routes',
                args: ['%routeIds']
            },

            validity: {
                module: 'core/validity.dsl',
                init: 'factory',
                args: [
                    '@validityModFactory',
                    '@validations.rules',
                    '@paymentsRules',
                    'PlatformValidation:newCasumoName:createIntermediatePlayer/casumoName:common',
                    'PlatformValidation:newEmail:createIntermediatePlayer/email:common',
                    'PlatformValidation:oldEnoughToPlay:registerPlayer/dateOfBirth:common'
                ]
            },

            validityModFactory: {
                module: 'core/validity.createValidityMod',
                init: 'partial',
                args: ['LOG.error']
            },

            /**
             * Hard to categorise
             */
            googleTagManagerEvents: {
                module: 'core/GoogleTagManagerEvents',
                args: ['@googleTagManager'],
                extras: [
                    {
                        subscribe: {
                            'onDeposit': 'onDeposit',
                            'onWithdraw': 'onWithdraw',
                            'onRegistration': 'onRegistration'
                        }
                    }
                ]
            },

            noop: {
                module: 'utils/noop',
                init: 'return'
            },

            /**
             * Payments
             */
            depositViewModel: {
                module: 'viewmodels/pages/cash/deposit',
                args: [
                    '@session',
                    '@navigation',
                    '@chooseDepositValuableViewModel',
                    '@CancelPendingWithdrawalsViewModel',
                    '@PlayOkLimitsReachedViewModel',
                    '@paymentMethods',
                    '@paymentMethodFactory.depositMethodViewModel',
                    '@cashTabs',
                    'fe:wp:page:root:mobile/deposit',
                    '@depositModel',
                    '@plugins/dialog',
                    '@ChooseDepositValuableDialog',
                    '@showError',
                    '@PaymentWizard'
                ]
            },
            paymentMethodTypeInMaintenanceViewModel: {
                module: 'viewmodels/pages/cash/PaymentMethodTypeInMaintenanceViewModel',
                args: [
                    'fe:wp:page:root:shared/payment-method-type-in-maintenance'
                ]
            },
            PlayOkLimitsReachedViewModel: {
                module: 'viewmodels/pages/cash/deposit/playOkLimitsReached',
                init: 'partial',
                args: ['fe:wp:page:root:shared/play-ok-limits-reached']
            },
            CancelPendingWithdrawalsViewModel: {
                module: 'viewmodels/pages/cash/deposit/cancelWithdrawal',
                init: 'partial',
                args: [
                    '@navigation',
                    '@TransactionListViewModel',
                    'fe:wp:page:root:mobile/deposit',
                    '@showError'
                ]
            },
            DepositAmountStep: {
                init: 'partial',
                module: 'viewmodels/pages/cash/AmountStepViewModel',
                args: [
                    '@depositFormFields',
                    '@session.player',
                    'wp:page:root:mobile/deposit',
                    '%true'
                ]
            },
            BokuDepositAmountStep: {
                init: 'partial',
                module: 'viewmodels/pages/cash/AmountStepViewModel',
                args: [
                    '@depositFormFields',
                    '@session.player',
                    'wp:page:root:mobile/deposit',
                    '%false'
                ]
            },
            WithdrawAmountStep: {
                init: 'partial',
                module: 'viewmodels/pages/cash/AmountStepViewModel',
                args: [
                    '@withdrawFormFields',
                    '@session.player',
                    'wp:page:root:mobile/withdraw',
                    '%true'
                ]
            },
            AddCreditCardDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/creditCard/AddCreditCardDeposit',
                args: [
                    '@validity',
                    '@values',
                    '@piqCryptoUtils'
                ]
            },
            AddCreditCardDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/creditCard/AddCreditCardDepositViewModel',
                args: [
                    '@session.player',
                    '@depositFormFields',
                    '@DepositAmountStep',
                    'wp:page:root:mobile/deposit'
                ]
            },
            UseCreditCardDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/creditCard/UseCreditCardDeposit',
                args: [
                    '@validity',
                    '@values'
                ]
            },
            UseCreditCardDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/creditCard/UseCreditCardDepositViewModel',
                args: [
                    '@formFields',
                    '@DepositAmountStep',
                    'wp:page:root:mobile/deposit'
                ]
            },
            UseCreditCardWithdrawModel: {
                init: 'partial',
                module: 'model/payments/methods/UseTokenOnlyMethod',
                args: ['%piq.CREDITCARD']
            },
            AddNetellerDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/neteller/AddNetellerDeposit',
                args: [
                    '@session',
                    '@validity',
                    '@values'
                ]
            },
            AddNetellerDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/neteller/AddNetellerDepositViewModel',
                args: [
                    '@DepositAmountStep',
                    '@depositFormFields',
                    'wp:page:root:mobile/deposit'
                ]
            },
            AddOrUseBankDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/envoy/EnvoyAwareTypeOnlyMethod',
                args: ['%piq.BANK', '%piq.ENVOY_BANKTRANSFER', '@session.player']
            },
            AddBankWithdrawModel: {
                init: 'partial',
                module: 'model/payments/methods/bank/AddBankWithdraw',
                args: [
                    '@validity',
                    '@values'
                ]
            },
            AddBankWithdrawViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/bank/AddBankWithdrawViewModel',
                args: [
                    '@withdrawFormFields',
                    '@WithdrawAmountStep',
                    'fe:wp:page:root:mobile/withdraw'
                ]
            },
            UseBankWithdrawModel: {
                init: 'partial',
                module: 'model/payments/methods/UseTokenOnlyMethod',
                args: ['%piq.BANK']
            },
            UseNetellerDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/neteller/UseNetellerDeposit',
                args: [
                    '@validity',
                    '@values'
                ]
            },
            UseNetellerDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/neteller/UseNetellerDepositViewModel',
                args: [
                    '@DepositAmountStep',
                    '@depositFormFields',
                    'wp:page:root:mobile/deposit'
                ]
            },
            UseNetellerWithdrawModel: {
                init: 'partial',
                module: 'model/payments/methods/UseTokenOnlyMethod',
                args: ['%piq.NETELLER']
            },
            AddSkrillDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/skrill/AddSkrillDeposit',
                args: ['@values']
            },

            AddSkrillDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/skrill/AddSkrillDepositViewModel',
                args: [
                    '@DepositAmountStep',
                    '@depositFormFields',
                    'wp:page:root:mobile/deposit'
                ]
            },
            UseSkrillModel: {
                init: 'partial',
                module: 'model/payments/methods/UseTokenOnlyMethod',
                args: ['%piq.SKRILL']
            },
            AddPugglePayDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/TypeOnlyMethod',
                args: ['%piq.PUGGLEPAY']
            },
            UsePugglePayDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/UseTokenOnlyMethod',
                args: ['%piq.PUGGLEPAY']
            },
            AddOrUsePaysafeCardDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/envoy/EnvoyAwareTypeOnlyMethod',
                args: ['%piq.PAYSAFECARD', '%piq.ENVOY_PAYSAFECARD', '@session.player']
            },
            AddOrUseIdealDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/envoy/EnvoyAwareTypeOnlyMethod',
                args: ['%emptyString', '%piq.ENVOY_IDEAL', '@session.player']
            },
            AddOrUseSofortDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/envoy/EnvoyAwareTypeOnlyMethod',
                args: ['%emptyString', '%piq.ENVOY_SOFORT', '@session.player']
            },
            AddOrUseGiropayDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/envoy/EnvoyAwareTypeOnlyMethod',
                args: ['%emptyString', '%piq.ENVOY_GIROPAY', '@session.player']
            },
            AddBokuDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/boku/AddBokuDeposit',
                args: [
                    '@values',
                    '%bokuMoneyChoices',
                    '@session.player'
                ]
            },
            UseBokuDepositModel: {
                init: 'partial',
                module: 'model/payments/methods/boku/UseBokuDeposit',
                args: [
                    '%bokuMoneyChoices'
                ]
            },
            AddBokuDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/boku/AddBokuDepositViewModel',
                args: [
                    '@BokuDepositAmountStep',
                    '@depositFormFields',
                    'wp:page:root:mobile/deposit'
                ]
            },
            UseBokuDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/boku/UseBokuDepositViewModel',
                args: [
                    '@BokuDepositAmountStep'
                ]
            },
            AmountOnlyDepositViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/AmountOnlyViewModel',
                args: [
                    '@DepositAmountStep',
                    '@navigation'
                ]
            },
            AmountOnlyWithdrawViewModel: {
                init: 'partial',
                module: 'viewmodels/pages/cash/methods/AmountOnlyViewModel',
                args: [
                    '@WithdrawAmountStep',
                    '@navigation'
                ]
            },
            paymentMethodFactory: {
                module: 'model/payments/PaymentMethodFactory',
                args: ['@paymentMethodsConfig']
            },
            paymentMethodsConfig: {
                structuredArg: [
                    {
                        type: '%piq.types.CREDITCARD',
                        deposit: {
                            add: {
                                model: '@AddCreditCardDepositModel',
                                viewModel: '@AddCreditCardDepositViewModel'
                            },
                            use: {
                                model: '@UseCreditCardDepositModel',
                                viewModel: '@UseCreditCardDepositViewModel'
                            }
                        },
                        withdraw: {
                            use: {
                                model: '@UseCreditCardWithdrawModel',
                                viewModel: '@AmountOnlyWithdrawViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.PUGGLEPAY',
                        deposit: {
                            add: {
                                model: '@AddPugglePayDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@UsePugglePayDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.SKRILL',
                        deposit: {
                            add: {
                                model: '@AddSkrillDepositModel',
                                viewModel: '@AddSkrillDepositViewModel'
                            },
                            use: {
                                model: '@UseSkrillModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        },
                        withdraw: {
                            use: {
                                model: '@UseSkrillModel',
                                viewModel: '@AmountOnlyWithdrawViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.NETELLER',
                        deposit: {
                            add: {
                                model: '@AddNetellerDepositModel',
                                viewModel: '@AddNetellerDepositViewModel'
                            },
                            use: {
                                model: '@UseNetellerDepositModel',
                                viewModel: '@UseNetellerDepositViewModel'
                            }
                        },
                        withdraw: {
                            use: {
                                model: '@UseNetellerWithdrawModel',
                                viewModel: '@AmountOnlyWithdrawViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.BANK_DEPOSIT',
                        deposit: {
                            add: {
                                model: '@AddOrUseBankDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@AddOrUseBankDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.BANK_WITHDRAW',
                        withdraw: {
                            add: {
                                model: '@AddBankWithdrawModel',
                                viewModel: '@AddBankWithdrawViewModel'
                            },
                            use: {
                                model: '@UseBankWithdrawModel',
                                viewModel: '@AmountOnlyWithdrawViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.PAYSAFECARD',
                        deposit: {
                            add: {
                                model: '@AddOrUsePaysafeCardDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@AddOrUsePaysafeCardDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.IDEAL',
                        deposit: {
                            add: {
                                model: '@AddOrUseIdealDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@AddOrUseIdealDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.SOFORT',
                        deposit: {
                            add: {
                                model: '@AddOrUseSofortDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@AddOrUseSofortDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.GIROPAY',
                        deposit: {
                            add: {
                                model: '@AddOrUseGiropayDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            },
                            use: {
                                model: '@AddOrUseGiropayDepositModel',
                                viewModel: '@AmountOnlyDepositViewModel'
                            }
                        }
                    },
                    {
                        type: '%piq.types.BOKU',
                        deposit: {
                            add: {
                                model: '@AddBokuDepositModel',
                                viewModel: '@AddBokuDepositViewModel'
                            },
                            use: {
                                model: '@UseBokuDepositModel',
                                viewModel: '@UseBokuDepositViewModel'
                            }
                        }
                    }
                ]
            },
            sendPiqWithdrawRequest: {
                init: 'partial',
                module: 'model/payments/sendPiqRequest',
                args: ['@piqApi.withdraw']
            },
            withdrawModel: {
                module: 'model/payments/WithdrawModel',
                args: [
                    '@values',
                    '@validity',
                    '@paymentMethodFactory.withdrawMethodModel',
                    '@sendPiqWithdrawRequest',
                    '@absoluteUrls.waitForTransactionUrl',
                    'publish:onWithdraw'
                ]
            },
            withdrawViewModel: {
                module: 'viewmodels/pages/cash/withdraw',
                args: [
                    '@session',
                    '@paymentMethods',
                    '@cashTabs',
                    'fe:wp:page:root:mobile/withdraw',
                    '@paymentMethodFactory.withdrawMethodViewModel',
                    '@withdrawModel',
                    '@plugins/dialog',
                    '@navigation',
                    '@showError',
                    '@ChoiceAlert',
                    '@PaymentWizard'
                ]
            },
            TransactionListViewModel: {
                module: 'viewmodels/pages/cash/TransactionListViewModel',
                init: 'partial',
                args: [
                    '@navigation',
                    'fe:wp:page:root:mobile/payment-history',
                    'fe:wp:page:root:mobile/deposit',
                    '@plugins/dialog',
                    '@showError',
                    '@TransactionReceiptDialog',
                    'wp:page:root:mobile/transaction-receipt'
                ]
            },
            betsListViewModel: {
                module: 'viewmodels/pages/cash/history/bets',
                init: 'partial',
                args: [
                    '@gameRounds',
                    'fe:wp:page:root:mobile/bet-history'
                ]
            },
            historyViewModel: {
                module: 'viewmodels/pages/cash/history',
                args: [
                    '@session',
                    '@navigation',
                    'fe:wp:page:root:mobile/payment-history',
                    '@cashTabs',
                    '@TransactionListViewModel',
                    '@betsListViewModel'
                ]
            },
            chooseDepositValuableViewModel: {
                module: 'viewmodels/pages/cash/deposit/ChooseDepositValuableViewModel',
                args: ['fe:wp:page:root:mobile/deposit']
            },

            /**
             * ViewModel - Games
             */
            gamesTabs: {
                module: 'viewmodels/pages/games/gamesTabs',
                args: [
                    '@navigation',
                    'fe:wp:page:root:mobile/top-games',
                    'fe:wp:page:root:mobile/all-games',
                    'fe:wp:page:root:mobile/games-search'
                ],
                init: 'factory'
            },

            allGamesViewModel: {
                module: 'viewmodels/pages/games/all',
                args: [
                    '@gameBrowser',
                    '@gamesTabs',
                    'fe:wp:page:root:mobile/all-games'
                ]
            },

            searchGamesViewModel: {
                module: 'viewmodels/pages/games/search',
                args: [
                    '@gameBrowser',
                    '@gamesTabs',
                    'fe:wp:page:root:mobile/games-search'
                ]
            },

            topGamesViewModel: {
                module: 'viewmodels/pages/games/top',
                args: [
                    '@gameTopLists',
                    '@gamesTabs',
                    'fe:wp:page:root:mobile/top-games',
                    'fe:wp:page:root:mobile/all-games',
                    '@mediaResponder'
                ]
            },

            gamesHeader: {
                module: 'viewmodels/pages/games/gamesHeader',
                args: [
                    '@session',
                    '@welcomeOffers',
                    'fe:wp:page:root:mobile/onboarding',
                    '@tournamentCampaignsViewModel'
                ]
            },

            changePasswordViewModel: {
                module: 'viewmodels/pages/changePassword',
                args: [
                    '@changePasswordModel',
                    'fe:wp:page:root:mobile/change-password',
                    '@ForgotPasswordDialog',
                    '@formFields'
                ]
            },

            unsubscribeViewModel: {
                module: 'viewmodels/pages/unsubscribe',
                args: [
                    '@session',
                    '@players',
                    '@Notification',
                    '@googleTagManager',
                    'PlatformCmd:unsubscribePlayerFromNewsletter:common',
                    'fe:wp:page:root:mobile/menu',
                    'fe:wp:page:root:mobile/unsubscribe'
                ]
            },
            menuViewModel: {
                module: 'viewmodels/menu',
                args: [
                    '@session',
                    'PlatformCmd:logout:common',
                    '@plugins/router',
                    'fe:wp:page:root:mobile/menu',
                    'fe:wp:page:root:mobile/global-assets',
                    '@olarkService',
                    '@settings.selectedCountry'
                ]
            },
            footerViewModel: {
                module: 'viewmodels/footer',
                args: [
                    '@session',
                    'fe:wp:page:root:mobile/footer'
                ]
            },
            'widgets/nextTournamentBanner/viewmodel': {
                module: 'widgets/nextTournamentBanner/viewmodel',
                args: [
                    '@tournamentCampaignsViewModel'
                ],
                init: 'partial'
            },
            'widgets/tournamentTracker/viewmodel': {
                module: 'widgets/tournamentTracker/viewmodel',
                args: [
                    '@tournamentCampaignsViewModel'
                ],
                init: 'partial'
            },
            'widgets/languageSelector/viewmodel': {
                module: 'widgets/languageSelector/viewmodel',
                args: [
                    '@internationalization',
                    '@navigation',
                    '@settings'
                ],
                init: 'partial'
            },
            'widgets/casumo/viewmodel': {
                module: 'widgets/casumo/viewmodel',
                args: [
                    '@session',
                    '@adventurers'
                ],
                init: 'partial'
            },
            'widgets/casumo2/viewmodel': {
                module: 'widgets/casumo2/viewmodel',
                args: [
                    '@casumos'
                ],
                init: 'partial'
            },
            'widgets/balance/viewmodel': {
                module: 'widgets/balance/viewmodel',
                args: ['@session'],
                init: 'partial'
            },
            'widgets/flipSwitch/viewmodel': {
                module: 'widgets/flipSwitch/viewmodel',
                args: [],
                init: 'partial'
            },
            valuableDgridBlock: {
                module: 'widgets/dgrid/blocks/valuable/valuable',
                args: [
                    '@session',
                    '@itemManager',
                    '@adventurers',
                    'fe:wp:page:root:mobile/dashboard/dgrid/available-valuable/'
                ]
            },
            lastPlayedDgridBlock: {
                module: 'widgets/dgrid/blocks/lastplayed/lastPlayed',
                args: [
                    '@DGridData',
                    '@games',
                    'fe:wp:page:root:mobile/dashboard/dgrid/last-played-game/'
                ]
            },
            recommendedDgridBlock: {
                module: 'widgets/dgrid/blocks/recommended/recommended',
                args: [
                    '@DGridData',
                    '@games',
                    'fe:wp:page:root:mobile/dashboard/dgrid/recommended-game/'
                ],
                init: 'partial'
            },
            curatedContentDgridBlock: {
                module: 'widgets/dgrid/blocks/curatedContent/curatedContent',
                args: [
                    'fe:wp:page:root:mobile/dashboard/dgrid/curated-content/',
                    '@games'
                ]
            },
            reelRacesBlock: {
                module: 'widgets/dgrid/blocks/reelRaces/reelRaces',
                args: [
                    '@tournamentCampaignsViewModel',
                    'fe:wp:page:root:reel-races/reel-race-templates'
                ]
            },
            reelRacesBlockBig: {
                module: 'widgets/dgrid/blocks/reelRacesBig/reelRacesBig',
                args: [
                    '@tournamentCampaignsViewModel',
                    'fe:wp:page:root:mobile/dashboard/dgrid/reel-races-big',
                    '@ReelRacesHowItWorksDialog',
                    '@plugins/dialog',
                    '@session.player'
                ]
            },
            trophiesBlock: {
                module: 'widgets/dgrid/blocks/trophies/trophies',
                args: [
                    '@session',
                    '@adventurers',
                    '@plugins/dialog',
                    '@TrophiesDialog',
                    'fe:wp:page:root:mobile/adventure'
                ]
            },
            allGamesBlock: {
                module: 'widgets/dgrid/blocks/allGames/allGames',
                args: [
                    'fe:wp:page:root:mobile/dashboard/dgrid/all-games'
                ]
            },
            DGridData: {
                module: 'widgets/dgrid/utils/DGridData',
                args: [
                    '@session'
                ]
            },
            DGridBlock: {
                module: 'widgets/dgrid/utils/DGridBlock',
                init: 'partial'
            },
            'widgets/dgrid/viewmodel': {
                module: 'widgets/dgrid/viewmodel',
                args: [
                    '@valuableDgridBlock',
                    '@lastPlayedDgridBlock',
                    '@curatedContentDgridBlock',
                    '@recommendedDgridBlock',
                    '@reelRacesBlock',
                    '@trophiesBlock',
                    '@reelRacesBlockBig',
                    '@allGamesBlock',
                    '@DGridBlock'
                ],
                init: 'partial'
            },
            'widgets/valuablesList/viewmodel': {
                module: 'widgets/valuablesList/viewmodel',
                args: [
                    '@itemManager',
                    'fe:wp:page:root:mobile/valuables'
                ],
                init: 'partial'
            },
            'widgets/gamesList/viewmodel': {
                module: 'widgets/gamesList/viewmodel',
                args: ['fe:wp:page:root:mobile/game-details'],
                init: 'partial'
            },
            'widgets/depositValuablesList/viewmodel': {
                module: 'widgets/depositValuablesList/viewmodel',
                args: [
                    '@session',
                    '@itemManager',
                    'fe:wp:page:root:mobile/deposit'
                ],
                init: 'partial'
            },
            'widgets/donut/viewmodel': {
                module: 'widgets/donut/viewmodel',
                args: [],
                init: 'partial'
            },
            'widgets/donut2/viewmodel': {
                module: 'widgets/donut2/viewmodel',
                args: [],
                init: 'partial'
            },
            'widgets/trophiesList/viewmodel': {
                module: 'widgets/trophiesList/viewmodel',
                args: [
                    'fe:wp:page:root:mobile/adventure',
                    '@games'
                ]
            },
            'widgets/questPath/viewmodel': {
                module: 'widgets/questPath/viewmodel',
                args: [],
                init: 'partial'
            },

            olarkService: {
                module: 'widgets/olark/olarkService',
                args: [
                    '@olarkMobileDialogFactory',
                    '@helpViewModel'
                ]
            },

            olarkLoginModel: {
                module: 'widgets/olark/olarkLoginModel',
                args: [
                    '@validity',
                    '@values'
                ]
            },

            olarkOperator: {
                module: 'widgets/olark/helper/olarkOperator',
                args: [
                    '@olarkStorage',
                    '%olarkSelectors'
                ]
            },

            olarkSelectors: {
                module: 'widgets/olark/helper/olarkSelectors'
            },

            olarkSpecificSession: {
                module: 'widgets/olark/olarkSpecificSession',
                args: ['@session.player']
            },

            helpViewModel: {
                module: 'widgets/olark/viewmodel',
                args: [
                    'fe:wp:page:root:mobile/menu',
                    '@durandal/app',
                    '@olark',
                    '@formFields',
                    'fe:wp:page:root:mobile/olark-mobile',
                    '@olarkLoginModel',
                    '@session',
                    '@olarkSpecificSession'
                ]
            },

            olarkMobileDialogFactory: {
                module: 'widgets/olark/dialog/olarkMobileDialogFactory',
                args: [
                    'fe:wp:page:root:mobile/menu',
                    '@HelpDialog'
                ]
            },

            olarkCode: {
                module: 'widgets/olark/olarkCode',
                init: 'partial',
                args: []
            },

            olark: {
                module: 'widgets/olark/olark',
                args: [
                    '@session',
                    'fe:wp:page:root:mobile/olark-mobile',
                    'publish:openChat',
                    '@safeBrowsingEnabledStorage',
                    '@localStorageAccessorFactory.isLocalStorageEnabled',
                    '@olarkLoginModel',
                    '@formFields',
                    '@olarkSpecificSession',
                    '@olarkStorage',
                    '@olarkOperator',
                    '@olarkCode',
                    '%olarkId'
                ]
            },

            ChooseAccountDialog: {
                module: 'viewmodels/modals/dialogs/ChooseAccountDialog',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            ForgotPasswordDialog: {
                module: 'viewmodels/modals/dialogs/ForgotPasswordDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@forgotPasswordModel',
                    '@formFields'
                ]
            },
            FaqDialog: {
                module: 'viewmodels/modals/dialogs/FaqDialog',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            FaqDialogTablet: {
                module: 'viewmodels/modals/dialogs/FaqDialogTablet',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            ReelRacesHowItWorksDialog: {
                module: 'viewmodels/modals/dialogs/ReelRacesHowItWorksDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'wp:page:root:mobile/tournament-campaigns',
                    '@session'
                ]
            },
            PlayOkayDialog: {
                module: 'viewmodels/modals/dialogs/PlayOkayDialog',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            HelpDialog: {
                module: 'viewmodels/modals/dialogs/HelpDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'publish:onMenuClosed',
                    '@helpViewModel'
                ]
            },
            TermsDialog: {
                module: 'viewmodels/modals/dialogs/TermsDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'wp:page:root:toc',
                    '@vocabulary'
                ]
            },
            ItunesTermsDialog: {
                module: 'viewmodels/modals/dialogs/ItunesTermsDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'fe:wp:page:root:shared/itunes-terms'
                ]
            },
            ItunesTerms: {
                module: 'viewmodels/pages/itunesTerms',
                args: [
                    'fe:wp:page:root:shared/itunes-terms'
                ]
            },
            TrophiesDialog: {
                module: 'viewmodels/modals/dialogs/TrophiesDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'fe:wp:page:root:mobile/adventure'
                ]
            },
            CookieDialog: {
                module: 'viewmodels/modals/dialogs/CookieDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'fe:wp:page:root:toc/privacy-cookie-policy'
                ]
            },
            ChooseDepositValuableDialog: {
                module: 'viewmodels/modals/dialogs/ChooseDepositValuableDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    'fe:wp:page:root:mobile/deposit'
                ]
            },
            TransactionReceiptDialog: {
                module: 'viewmodels/modals/dialogs/TransactionReceiptDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@showError',
                    'fe:wp:page:root:mobile/transaction-receipt',
                    'fe:wp:page:root:mobile/deposit'
                ]
            },
            NotificationsDialog: {
                module: 'viewmodels/modals/dialogs/NotificationsDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@actionProvider'
                ]
            },
            QuestInfoDialog: {
                module: 'viewmodels/modals/dialogs/QuestInfoDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@session',
                    '@quests',
                    '@leaderboards'
                ]
            },
            QuestChooserDialog: {
                module: 'viewmodels/modals/dialogs/QuestChooserDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@quests',
                    '@questChooser',
                    '@MessageAlert'
                ]
            },
            QuestLeaderboardDialog: {
                module: 'viewmodels/modals/dialogs/QuestLeaderboardDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@leaderboards'
                ]
            },
            CouponDialog: {
                module: 'viewmodels/modals/dialogs/CouponDialog',
                init: 'partial',
                args: [
                    'fe:wp:page:root:shared/itunes-coupon',
                    '@ItunesTermsDialog'
                ]
            },
            TicketDialog: {
                module: 'viewmodels/modals/dialogs/TicketDialog',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            ChangeEmailDialog: {
                module: 'viewmodels/modals/dialogs/ChangeEmailDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@formFields',
                    '@settingsModel',
                    '@ErrorAlert',
                    'fe:wp:page:root:mobile/settings/change-email',
                    '@sessionHistory'
                ]
            },
            ChangePasswordDialog: {
                module: 'viewmodels/modals/dialogs/ChangePasswordDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@formFields',
                    '@settingsModel',
                    'fe:wp:page:root:mobile/change-password',
                    'fe:wp:page:root:mobile/settings/change-email'
                ]
            },
            ChangeMobileNumberDialog: {
                module: 'viewmodels/modals/dialogs/ChangeMobileNumberDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@formFields',
                    '@settingsModel',
                    '@Wizard',
                    'fe:wp:page:root:mobile/settings/verify-mobile-number',
                    '@navigation'
                ]
            },
            VerifyMobileNumberDialog: {
                module: 'viewmodels/modals/dialogs/VerifyMobileNumberDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@formFields',
                    'fe:wp:page:root:mobile/settings/verify-mobile-number',
                    '@session.player',
                    '@settingsModel',
                    '@Command',
                    '@PlatformCommandDispatcher',
                    '@values',
                    '@validity',
                    '@navigation'
                ]
            },
            ChangeRealityCheckIntervalDialog: {
                module: 'viewmodels/modals/dialogs/ChangeRealityCheckIntervalDialog',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@formFields',
                    '@changeRealityCheckIntervalModel',
                    'wp:page:root:shared/reality-check'
                ]
            },
            ErrorAlert: {
                module: 'viewmodels/modals/alerts/ErrorAlert',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            ChoiceAlert: {
                module: 'viewmodels/modals/alerts/ChoiceAlert',
                init: 'partial',
                args: ['@plugins/dialog']
            },
            MessageAlert: {
                module: 'viewmodels/modals/alerts/MessageAlert',
                init: 'partial',
                args: [
                    '@plugins/dialog',
                    '@vocabulary'
                ]
            },
            GameMessagesHandler: {
                module: 'core/GameMessagesHandler',
                args: [
                    '@plugins/dialog',
                    '@session',
                    '@GameMessagesAlert',
                    'wp:page:root:mobile/jurisdiction-information'
                ]
            },
            GameMessagesAlert: {
                module: 'viewmodels/modals/alerts/GameMessagesAlert',
                init: 'partial',
                args: ['@plugins/dialog']
            },

            /**
             * Game Providers
             */
            netEntGameProvider: {
                module: 'gameProviders/NetEntGameProvider',
                args: ['@navigation']
            }
        })
    };

    return {
        get: function () {
            return composition;
        },
        registerModuleDependencies: function (dependencies, module) {

            _(dependencies).forEach(function (config, key) {
                config.module = 'features/' + module + '/' + config.module;
                composition.services[key] = config;
            });
        }
    };

});

